import { render, staticRenderFns } from "./ReceiptAdd.vue?vue&type=template&id=49277554&scoped=true&"
import script from "./ReceiptAdd.vue?vue&type=script&lang=js&"
export * from "./ReceiptAdd.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptAdd.vue?vue&type=style&index=0&id=49277554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49277554",
  null
  
)

export default component.exports